import React from 'react';
import styled from 'styled-components';
import { Icon, IconName } from '../../Icon';

import { LoaderSpinnerProps } from './Interfaces';

export const LoaderSpinner = ({
  absolute,
  position = 'center',
  size = 'medium',
}: LoaderSpinnerProps) => {
  return (
    <StyledLoader position={position} size={size} absolute={absolute}>
      <Icon name={IconName.b2cLoading} />
    </StyledLoader>
  );
};

const StyledLoader = styled.div<LoaderSpinnerProps>`
  position: ${({ absolute }) => (absolute ? 'absolute' : 'relative')};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;

  @keyframes spin-anim {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  svg {
    animation: spin-anim 1.2s linear infinite;
  }

  ${({ position }) =>
    position === 'start' &&
    'justify-content: flex-start; align-items: flex-start;'};
  ${({ position }) =>
    position === 'end' && 'justify-content: flex-end; align-items: flex-end;'};

  ${({ size, theme: { size: themeSize } }) =>
    `svg {width: ${themeSize[size].width}; height: ${themeSize[size].height}}`};
`;
